module.exports = __webpack_public_path__ + "images/application/help-menu-b56c0dde.svg";